import * as React from 'react';

import { Grid,  Button, Link } from '@material-ui/core';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { Trans, TransProps, WithTranslation, withTranslation } from 'react-i18next';

import { window2config } from '../../cfg/config';
import CONFIG from '../../cfg/config';

import { List, ListItem, Typography, ListItemText, ListItemIcon } from '@material-ui/core';
import { connect } from 'react-redux';

import { AppState, Actions, store, IPageState } from '../../appredux';

import { Doladowania } from '../../api';
import { ClassNameMap } from '@material-ui/styles';
import theme from '../../themes';

import DialogPlatnosc from './DialogPlatnosc';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart'
import LoaderNoWindow from 'components/LoaderNoWindow';
import DialogLink from 'components/DialogLink';
import { sendErrorLog } from 'common/helpers';


interface DoladujKarnetProps {
  page: IPageState,
}

interface DoladujKarnetState {
  openZajety: boolean,
  openPlatnosc: boolean,
  platnosc: Doladowania,
  openLink: boolean,
}

class DoladujKarnet extends React.Component<DoladujKarnetProps & WithTranslation & TransProps & WithStyles<typeof styles>, DoladujKarnetState> {

  constructor(props: DoladujKarnetProps & WithTranslation & WithStyles<typeof styles>) {
    super(props, {});
    window2config();
   
    this.state = {
      openZajety: false,
      openPlatnosc: false,
      platnosc: new Doladowania(),
      openLink: false,
    }
  }

  componentDidMount() {
    sendErrorLog("1", "1", 'karnet czasowy')
  }

  openPlatnosc = (platnosc: Doladowania) => {
    //this.setState({ openPlatnosc: true, platnosc: platnosc })
    if(this.props.page.karnet.status === "Z"){
      this.setState({ openPlatnosc: true, platnosc: platnosc })
    } else {
      this.setState({openZajety: true})
    }
  }
  closePlatnosc = () => {
    this.setState({openPlatnosc: false})
  }
  openLink = () => {
    this.setState({openLink: true})
  }
  closeLink = () => {
    this.setState({openLink: false})
  }
  closeZajety = () => {
    this.setState({openZajety: false})
  }

  platnosc = async () => {
  }

  
  render() {
    const { classes, t } = this.props;
    let primary = theme.palette.primary.main

    let disabled = !this.props.page.jestKarnet
    let tablet = this.props.page.tablet
    
    let listItems: Doladowania[] = this.props.page.karnetCzasowy;


      return (
          <Grid container spacing={2} className={classes.container1} justify="center" alignItems="center"  >
              <Grid item xs={12} sm={12} className={classes.gridItem} >
                  {/* <Typography  variant="h6" component="h2" color="primary" gutterBottom style={{ fontSize: "1.5rem", color: "lightseagreen", textAlign: "center", marginBottom: "1em" }}>
                      <b >{"Doładuj karnet"}</b>
                  </Typography> */}

                  <div style={{ width: "fit-content", margin: "auto" }}>
                    {listItems.length === 0 ? <LoaderNoWindow/> :
                    listItems.map((item: Doladowania, index: number) =>
                      <Typography variant="h6" component="h2" color='textSecondary' onClick={() => CONFIG.karnetPlatnoscLink !== "1" ? this.openLink() : !disabled ? this.openPlatnosc(item) : store.dispatch(Actions.pageState.setOpenInfo())} className={classes.text} style={{fontSize: tablet ? "18px" : "16px"}}>
                        <AddShoppingCartIcon className={classes.icon} />
                        <Link target='_blank' underline="hover" className={classes.color} style={{fontWeight: this.props.page.karnetDoladowania[0] && item.wwwOpis === this.props.page.karnetDoladowania[0].jrWplataDefWwwOpis ? "bold" : "normal"}}>{item.wwwOpis}</Link>
                        {/* {"Ty lajkujesz"}<b className={classes.primary} >{ }</b> */}
                      </Typography>
                    )}
                  </div>           

                  <DialogLink open={this.state.openLink} close={this.closeLink} title="doładuj" text="funkcja chwilowo wyłączona" />
                  <DialogLink open={this.state.openZajety} close={this.closeZajety} title="doładuj" text="karnet nie jest zajęty" />
                  
                  <DialogPlatnosc open={this.state.openPlatnosc} closeDialog={this.closePlatnosc} potwierdz={this.platnosc} platnosc={this.state.platnosc} />

                  {/* <Button className={`${classes.button}`} variant="contained" color="primary"
          //style={{ color: bramka.kolor, background: colors[index]}}
          //style={{ background: bramka.kolor}}
          //onClick={() => this.reset()}
          >
            {t("Reset")}
          </Button> */}

              </Grid>
          </Grid>
      );
  }
}

const styles = (theme: Theme) => ({
  container1: {
    //margin: "0em",
    //paddingTop: "0.4em",
    margin: "30px auto 0px",
    padding: '0em 0em',
    minHeight: "100%",
    maxWidth: "1340px",
    //border: "2px solid lavender"
  },
  gridItem: {
    //minHeight: "150px",
  },
  item: {
    height: "80px",
    textAlign: "center" as "center",
    border: "1px solid lavender",
    marginBottom: "4px",
    backgroundColor: "#FCFCFC", //"#F5F5F5",
    "&:hover": {
      backgroundColor: "#F1F1F1", //"#EEE"
    },
  },
  itemText: {
    color: "rgb(255, 165, 0)",
    fontSize: "16px"//"2.5rem"
  },
  color: {
    color: "lightseagreen",
  },
  text: {
    color: theme.palette.text.secondary,
    whiteSpace: "pre" as "pre",
    minHeight: "12px",
    marginBottom: '20px',
    fontSize: "16px",

    display: "flex" as "flex",
    //justyfyContent: "center",
    alignItems: "center",
    cursor: "pointer"
  },
  icon: {
    fontSize: "30px", 
    color: "rgb(255, 165, 0)", 
    marginRight: "10px"
  },
 
  
 
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(DoladujKarnet))); 

